import { PlaybackVideoJsPlayer } from '@app/core/video-player/PlaybackVideoJsPlayer';
import { useMemo } from 'react';
import { useStationLiveHlsUrl } from '../../../modules/logger/screens/stream/modes/video/useStationLiveHlsUrl';
import { useHlsClockSync } from '../hooks/useHlsClockSync';

/**
 * Live HLS player for a station. Computes the stream URL from stationId via useStationLiveHlsUrl.
 */
export function StationLivePlayer({
  stationId,
  onClockUpdate,
  options: optionsProp,
}: {
  stationId: string;
  onClockUpdate?: (time: Date) => void;
  /** Player options (autoplay, muted, etc.). Merged with defaults. */
  options?: Partial<Record<string, any>>;
}) {
  const src = useStationLiveHlsUrl(stationId);

  const options = useMemo(
    () => ({
      controlBar: false,
      enableDocumentPictureInPicture: true,
      autoplay: true,
      muted: true,
      ...optionsProp,
    }),
    [optionsProp],
  );

  const onReady = useHlsClockSync(onClockUpdate);

  if (!src) {
    return null;
  }

  return <PlaybackVideoJsPlayer isLive options={options} onReady={onReady} />;
}
